/*
  submenu
*/
/**
 * Desktop/Mobile SUBMENU script
 * Works with options & page code name
 */

/**
 * Mobile SUBMENU script
 * Works with body code name
 */
var submenu = $("[class^=mob_submenu_inline-]");

if (submenu.length) {
  var main_class_trigger = false;

  submenu.each(function() {
    var _this = $(this);
    var submenu_items = _this.find(".item");

    submenu_items.each(function() {
      if ($(this).attr("data-page-code") == PAGE_CODE) {

        $(this).addClass("active"); //highlight selected item
        _this.show(); // show submenu if PAGE_CODE match one of the items
        main_class_trigger = true;
      }
    });
  });

  if (main_class_trigger) { //tell the document it has a submenu
    $("main").addClass("has-submenu");
  }
}


/**
 * Desktop SUBMENU script
 * Works with body code name
 */
var PAGE_CODE = $("body").attr("data-code");
var desk_submenu = $("[class^=desk_submenu_inline-]");
var desk_submenu_items = desk_submenu.find(".item");
var desk_sub_show = false;

desk_submenu_items.each(function() {
  if ($(this).attr("data-page-code") == PAGE_CODE) {
    $(this).addClass("active");
    desk_sub_show = true;
  }
});

//== hide submenu if not relevant
if (!desk_sub_show) {
  desk_submenu.remove();
}
